import { render, staticRenderFns } from "./GameWxBroad.vue?vue&type=template&id=02531202&scoped=true&"
import script from "./GameWxBroad.vue?vue&type=script&lang=js&"
export * from "./GameWxBroad.vue?vue&type=script&lang=js&"
import style0 from "./GameWxBroad.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GameWxBroad.vue?vue&type=style&index=1&lang=css&"
import style3 from "./GameWxBroad.vue?vue&type=style&index=3&id=02531202&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02531202",
  null
  
)

export default component.exports